/**
 * 处理paymentMethods的utility函数，负责将paymentMethods在数组和isWalletWithhold和isAlipayWithhold之间互转
 * isWalletWithhold和isAlipayWithhold的取值为0或1
 * paymentMethods的取值为PAYMENT_METHOD.DRIVER_INCOME或PAYMENT_METHOD.ALIPAY
 */

import { PAYMENT_METHOD, PAYMENT_METHOD_TEXT, RENT_CATEGORY } from './config/enum'

/**
 * 将isWalletWithhold和isAlipayWithhold转换为paymentMethods数组
 * @param {number} isWalletWithhold
 * @param {number} isAlipayWithhold
 * @returns {Array}
 */
export const toPaymentMethodsArray = ({ isWalletWithhold, isAlipayWithhold } = {}) => {
  return [
    isWalletWithhold === 1 ? PAYMENT_METHOD.DRIVER_INCOME : undefined,
    isAlipayWithhold === 1 ? PAYMENT_METHOD.ALIPAY : undefined,
  ].filter(Boolean)
}

/**
 * 将paymentMethods数组转换为isWalletWithhold和isAlipayWithhold对象
 * @param {Array} paymentMethods
 * @returns {Object}
 */
export const toPaymentMethodsObj = (paymentMethods = []) => {
  return {
    isWalletWithhold: paymentMethods.includes(PAYMENT_METHOD.DRIVER_INCOME) ? 1 : 0,
    isAlipayWithhold: paymentMethods.includes(PAYMENT_METHOD.ALIPAY) ? 1 : 0,
  }
}

/**
 * 获取支付方式列表
 * @param {Object} params
 * @param {number} params.walletWithholdEnable 网约钱包支付是否开通
 * @param {number} params.alipayWithholdEnable 支付宝支付是否开通
 * @param {number} params.rentCategory 租赁模式
 * @returns {Array} 支付方式列表
 */
export const getPaymentMethods = ({
  walletWithholdEnable,
  alipayWithholdEnable,
  rentCategory,
} = {}) => {
  const list = []
  const unsupportedTip = (paymentMethod) => `${paymentMethod}未开通，请点击此处进行自主申请`

  // 网约钱包
  list.push({
    value: PAYMENT_METHOD.DRIVER_INCOME,
    label: PAYMENT_METHOD_TEXT[PAYMENT_METHOD.DRIVER_INCOME],
    enabled: walletWithholdEnable === 1,
    unsupportedTip: unsupportedTip(PAYMENT_METHOD_TEXT[PAYMENT_METHOD.DRIVER_INCOME]),
  })
  // 司机合作模式不支持支付宝划扣
  if (rentCategory !== RENT_CATEGORY.OWNER_OPERATOR_MODEL) {
    // 支付宝
    list.push({
      value: PAYMENT_METHOD.ALIPAY,
      label: PAYMENT_METHOD_TEXT[PAYMENT_METHOD.ALIPAY],
      enabled: alipayWithholdEnable === 1,
      unsupportedTip: unsupportedTip(PAYMENT_METHOD_TEXT[PAYMENT_METHOD.ALIPAY]),
    })
  }

  return list
}
